<template>
<div>
  <div class="row">
    <b-media>

      <img slot="aside" src="src/assets/projection.jpg" alt="Media Aside" />
      <h2>Проекционное оборудование</h2>
      <p>Проекторы, лампы для проекторов, экраны, светодиодные экраны, телевизоры и профессиональные панели, презентационное оборудование, лифты для проекторов, коммутационное оборудование.</p>




    </b-media>
    <app-alert v-if="load" show> </app-alert>
    <div v-if="!error" class="col col-xl-3 col-md-5" v-for="item in items" :key="item.id">
      <app-card :item=item></app-card>

      
    </div>
    <app-razr v-if="error"></app-razr>

  </div>
</div>
</template>

<script>
import Vue from 'vue'

import AppCard from "../components/AppCard.vue"
import AppAlert from "../components/AppAlert.vue"
import AppRazr from "../components/AppRazr.vue"

export default {
  created() {
    Vue.http.get(this.name + '.php')
      .then(response => {

          this.items = response.data.rows
          this.load = false
        },
        error => {
          console.log(error)
          this.load = false
          this.error = true
        }
      )
    //this.items = Serv
    //this.load = false



  },
  data() {
    return {
      items: [],
      name: this.$route.name,
      load: true,
      error: false

    }
  },
  components: {
    AppCard,
    AppAlert,
    AppRazr
  }

};
</script>

<style scoped>
 h1 {
    font-size: 2.5rem;
    text-align: center;
}
.row {
  justify-content: center;
  padding-right: 20px;
}

.col {
  border: 1px solid black;
  border-radius: 5px;
  margin: 10px;
  padding: 5px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  max-width: 250px
}

.media {
  flex-wrap: wrap;
  align-items: center;
  margin: 0px 30px;
  justify-content: center;
}

.media p {
  text-align: justify;
}

.media img {
  width: 350px;
  height: 250px;
  margin: 10px;
}


@media(max-width: 560px) {
  .media img {
    width: 280px;
    height: 200px;

  }

  .media {
    margin-right: 0px;

  }
}
</style>
